import { Badge, Carousel, Space, Icon, Typography } from '@sravni/react-design-system';
import type {
  IconColor,
  IconBackground,
} from '@sravni/react-design-system/dist/types/components/Icon/types/Icon.types';

import { CreditStepsItems } from '../constants';
import { CreditStepsTexts } from '../CreditSteps.texts';

import styles from './CreditSteps.module.scss';

export const CreditSteps: FC = (props) => {
  const { className } = props;
  return (
    <Carousel
      title={
        <Typography.Heading
          level={3}
          as="h2"
        >
          {CreditStepsTexts.title}
        </Typography.Heading>
      }
      className={className}
    >
      {CreditStepsItems.map((item, index) => (
        <div
          key={String(item.title)}
          className={styles.creditStepItem}
        >
          <Badge
            className={styles.badge}
            color="light"
            text={`Шаг ${index + 1}`}
          />
          <Space
            className={styles.title}
            direction="row"
            align="center"
            justify="space-between"
          >
            <Typography.Heading level={5}>{item.title}</Typography.Heading>
            <Icon
              shape="round"
              color={item.color as IconColor}
              background={item.color as IconBackground}
              icon={item.icon}
            />
          </Space>
          <Typography.Text>{item.subTitle}</Typography.Text>
        </div>
      ))}
    </Carousel>
  );
};
